const getUrl = process.env.REACT_APP_BASE_URL;

export const getAPIBaseUrl = (): string | undefined => {
  return getUrl;
}

export default getAPIBaseUrl; 